import { PersonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

export const INITIAL_STATE = {
  isArrayLoading: false,
  isArrayLoaded: false,
  arrayData: [],
  message: ''
};

const getGenderIdentityTypes = (state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/GenderIdentityType`;
    PersonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const GenderIdentityTypeData = { INITIAL_STATE, getGenderIdentityTypes };
export default GenderIdentityTypeData;